import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import PenaltyReportPageUI from './PenaltyReportPageUI.js'

class PenaltyReportPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      month: '',
      year: '',
      penaltyList: null,
      penalties: null,
      totalDefaultInterest: null,
      totalDefaultInterestTax: null,
      totalDefaultInterestPlusTax: null,
      totalDsraDipInterest: null,
      downloadSubmitted: false,
      sendingInternalEmail: false
    }
  }

  render() {
    return (
      <PenaltyReportPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        penaltyList={this.state.penaltyList}
        penalties={this.state.penalties}
        penalChargeFilteredList={this.state.penalChargeFilteredList}
        totalDefaultInterest={this.state.totalDefaultInterest}
        totalDefaultInterestTax={this.state.totalDefaultInterestTax}
        totalDefaultInterestPlusTax={this.state.totalDefaultInterestPlusTax}
        totalDsraDipInterest={this.state.totalDsraDipInterest}
        month={this.state.month}
        year={this.state.year}
        onRefreshClick={this.onRefreshClick}
        onDownloadClick={this.onDownloadClick}
        downloadSubmitted={this.state.downloadSubmitted}
        onSendInternalEmail={this.onSendInternalEmail}
        sendingInternalEmail={this.state.sendingInternalEmail}
        //
        showAccWithPenalCharge={this.state.showAccWithPenalCharge}
        onShowAccWithPenalChargeClick={() => { this.setState({ showAccWithPenalCharge: !this.state.showAccWithPenalCharge }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getPenalties(context)
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.year == prevProps.match.params.year && this.props.match.params.month == prevProps.match.params.month)
      return
    this.getPenalties(this.props.context)
  }

  getPenalties(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/penalties`,
      cacheKey: CacheKeys.Penalty(this.props.match.params.year, this.props.match.params.month),
      callback: this.getPenaltiesCallback,
      ttlInSecs: 60
    })
    // cacheManager.getObject2(context)
    if (!this.props.match.params.year || !this.props.match.params.month)
      cacheManager.getObject2(context, {}, {})
    else
      cacheManager.getObject2(context, {}, {
        year: this.props.match.params.year,
        month: this.props.match.params.month,
      })
  }

  getPenaltiesCallback = (response) => {
    let penalChargeFilteredList = response.penaltyAndNonComplianceList.filter(p => p.defaultInterestF5 !== null)
    this.setState({
      errorList: response.errorList,
      penalties: response,
      penaltyList: response.penaltyAndNonComplianceList,
      penalChargeFilteredList: penalChargeFilteredList,
      totalDsraDipInterest: response.dsraDipInterestF5,
      totalDefaultInterest: response.defaultInterestF5,
      totalDefaultInterestTax: response.defaultInterestTaxF5,
      totalDefaultInterestPlusTax: response.defaultInterestPlusTaxF5,
      month: response.month,
      year: response.year
    })
  }

  onDownloadClick = () => {
    this.setState({
      downloadErrorList: null,
      downloadSubmitted: true
    })
    let year = this.state.year || ''
    let month = this.state.month || ''
    RestApiUtils.get(this.props.context,
      `/api/su/loans/penalties/excel/fileDownloadSignedUrl?year=${year}&month=${month}`,
      this.onDownloadClickCallback, null, null
    )
  }

  onDownloadClickCallback = (response) => {
    this.setState({
      downloadErrorList: response.errorList,
      downloadSubmitted: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  onSendInternalEmail = () => {
    let sendingInternalEmail = this.state.sendingInternalEmail
    if (sendingInternalEmail)
      return

    this.setState({
      internalEmailSuccessMsg: null,
      internalEmailErrorList: [],
      sendingInternalEmail: true
    })

    let year = this.state.year || ''
    let month = this.state.month || ''
    RestApiUtils.post(this.props.context,
      `/api/su/loans/penalties/excel/email?year=${year}&month=${month}`,
      this.onSendInternalEmailCallback, {}
    )
  }

  onSendInternalEmailCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      internalEmailSuccessMsg: response.success,
      internalEmailErrorList: errorList,
      sendingInternalEmail: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          internalEmailSuccessMsg: null
        })
      }, 3000)
    }
  }

  onRefreshClick = () => {
    CacheManager.removeObject(CacheKeys.Penalty(this.props.match.params.year, this.props.match.params.month))
    this.setState({ penaltyList: null, errorList: null, penalties: null }, () => {
      this.getPenalties(this.props.context)
    })
  }

}

export default withRouter(PenaltyReportPageSF)
